import { CellEditConfig } from './cell-edit-config.model';

export interface FilterColumn {
  columnDef: string;
  value?: any;
  edit?: CellEditConfig<any>;
  computeFilterDataValueFn?: (val: any) => any;
}
